import { render, staticRenderFns } from "./weekly-export.vue?vue&type=template&id=89bc7c42&scoped=true"
import script from "./weekly-export.vue?vue&type=script&lang=js"
export * from "./weekly-export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bc7c42",
  null
  
)

export default component.exports